<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p style="white-space: pre">{{ data.text }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onYesClick()" color="warn" tabindex="2">
    {{ data.yes }}
  </button>
  <!-- Notice-style dialogs (session expired, provisioning result, navigation
       notices) pass only `yes`: without this guard they draw an empty button. -->
  @if (data.no) {
    <button mat-button (click)="onNoClick()" tabindex="-1">
      {{ data.no }}
    </button>
  }
</div>
